/* eslint-disable react/jsx-props-no-spreading */
import React, { memo } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { lodgingType, spaceTypes, unitMeasure } from "../data";
import { TextEditor } from "./TextEditor";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";

const InformationFields = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext(); // Access form context

  return (
    <div className="mt-4">
      <h4 className="mb-2 text-2xl font-bold">Information</h4>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="col-span-1">
          <label
            htmlFor="type_of_space"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Type of space
          </label>
          <Controller
            name="type_of_space"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="type_of_space"
                className={`w-full rounded-md border p-3  ${
                  errors?.type_of_space?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value="">Select a space type</option>
                {spaceTypes.map((option) => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}
          />
          {errors?.type_of_space?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.type_of_space?.message}
            </p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="lodging_type"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Lodging Type
          </label>
          <Controller
            name="lodging_type"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="lodging_type"
                className={`w-full rounded-md border p-3  ${
                  errors?.lodging_type?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value="">Select a lodging type</option>
                {lodgingType.map((option) => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}
          />
          {errors?.lodging_type?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.lodging_type?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4">
        <div className="col-span-1">
          <label
            htmlFor="title"
            className="!mb-2  text-sm flex items-center font-medium text-gray-700"
          >
            (Airport Identifier) Airport Name - Title
            <MdQuestionMark
              onClick={() =>
                Swal.fire({
                  text: `Please enter the airport identifier in parentheses, 
then a space, 
then the name of the airport, 
then space hyphen space, 
and then the title of your choice.`,
                  icon: "question",
                })
              }
              style={{
                color: "#fff",
                background: "#8ec639",
                borderRadius: "50%",
                fontWeight: "bold",
                fontSize: "1.2rem",
                marginLeft: "8px",
                boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
                border: "2px solid #8ec639",
                cursor: "pointer",
                padding: "2px",
                animation: "pulse-glow 1.2s infinite alternate",
              }}
              className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
              title="Info."
            />
          </label>
          <Controller
            name="title"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="title"
                type="text"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.title?.message ? "border-red-500" : "border-gray-300"
                }`}
                placeholder="(Airport Identifier) Airport Name - Title"
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.title?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.title?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="col-span-1">
          <label
            htmlFor="no_of_guest"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Number of Guests
          </label>
          <Controller
            name="no_of_guest"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="no_of_guest"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.no_of_guest?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.no_of_guest?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.no_of_guest?.message}
            </p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="no_of_bedrooms"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Number of Bedrooms
          </label>
          <Controller
            name="no_of_bedrooms"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="no_of_bedrooms"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.no_of_bedrooms?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.no_of_bedrooms?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.no_of_bedrooms?.message}
            </p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="no_of_beds"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Number of Beds
          </label>
          <Controller
            name="no_of_beds"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="no_of_beds"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.no_of_beds?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.no_of_beds?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.no_of_beds?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="col-span-1">
          <label
            htmlFor="no_of_bathrooms"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Number of Bathrooms
          </label>
          <Controller
            name="no_of_bathrooms"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="no_of_bathrooms"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.no_of_bathrooms?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.no_of_bathrooms?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.no_of_bathrooms?.message}
            </p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="no_of_rooms"
            className="mb-1 block text-sm font-medium text-gray-700"
          >
            Number of Rooms
          </label>
          <Controller
            name="no_of_rooms"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="no_of_rooms"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.no_of_rooms?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.no_of_rooms?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.no_of_rooms?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2">
        <div className="col-span-1">
          <label
            htmlFor="size"
            className="!mb-2  text-sm flex items-center font-medium text-gray-700"
          >
            Size
            <MdQuestionMark
              onClick={() =>
                Swal.fire({
                  text: `Please enter numbers only. You will be asked to choose square feet, square meters or acres in the next box.`,
                  icon: "question",
                })
              }
              style={{
                color: "#fff",
                background: "#8ec639",
                borderRadius: "50%",
                fontWeight: "bold",
                fontSize: "1.2rem",
                marginLeft: "8px",
                boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
                border: "2px solid #8ec639",
                cursor: "pointer",
                padding: "2px",
                animation: "pulse-glow 1.2s infinite alternate",
              }}
              className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
              title="Info."
            />
          </label>
          <Controller
            name="size"
            control={control}
            render={({ field: { onChange, value } }) => (
              <input
                id="size"
                type="number"
                className={`w-full rounded-md border px-4 py-3  ${
                  errors?.size?.message ? "border-red-500" : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors?.size?.message && (
            <p className="mt-1 text-sm text-red-500">{errors?.size?.message}</p>
          )}
        </div>
        <div className="col-span-1">
          <label
            htmlFor="unit_of_measure"
            className="!mb-2 block text-sm font-medium text-gray-700"
          >
            Unit of Measure
          </label>
          <Controller
            name="unit_of_measure"
            control={control}
            render={({ field: { onChange, value } }) => (
              <select
                id="unit_of_measure"
                className={`w-full rounded-md border p-3  ${
                  errors?.unit_of_measure?.message
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                value={value}
                onChange={onChange}
              >
                <option value="">Select a unit of measure</option>
                {unitMeasure.map((option) => (
                  <option key={option.key} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}
          />
          {errors?.unit_of_measure?.message && (
            <p className="mt-1 text-sm text-red-500">
              {errors?.unit_of_measure?.message}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-4">
        <div className="col-span-1">
          <p className="mb-1 text-start text-sm font-medium text-gray-700">
            Description
          </p>
          <div
            className={`${
              errors?.description?.message
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md border`}
          >
            <Controller
              name="description"
              control={control}
              render={({ field: { onChange, value } }) => (
                <div id="description">
                  <TextEditor
                    value={value}
                    onChange={(val) => {
                      onChange(val);
                    }}
                  />
                </div>
              )}
            />
          </div>
          {errors?.description?.message && (
            <small className="mt-1 block text-start text-sm text-red-500">
              {errors?.description?.message}
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(InformationFields);
